// extracted by mini-css-extract-plugin
module.exports = {"view-more__btn":"height-limited-expander_view-more__btn__lsK1W"};